import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchTeacherClassTests = createAsyncThunk(
    'teacherTests/fetchTeacherClassTests',
    async ({ classId, page = 1 }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('token3almny');
            const response = await axios.get(
                `https://newalemny.3almny.app/api/tests/my_class_tests/${classId}?page=${page}&per_page=12`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'حدث خطأ في تحميل الاختبارات'
            );
        }
    }
);

export const createTest = createAsyncThunk(
    'teacherTests/createTest',
    async (testData, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('token3almny');
            
            // Create FormData for file uploads
            const formData = new FormData();
            
            // Add basic test info
            formData.append('title', testData.title);
            formData.append('day', testData.day);
            formData.append('start_time', testData.start_time);
            formData.append('duration_time', testData.duration_time);
            formData.append('class_id', testData.class_id);
            formData.append('subject_id', testData.subject_id);
            
            // Handle added questions (new questions)
            if (testData.added_questions) {
                testData.added_questions.forEach((question, qIndex) => {
                    formData.append(`added_questions[${qIndex}][text]`, question.text);
                    formData.append(`added_questions[${qIndex}][question_degree]`, question.question_degree);
                    
                    if (question.image) {
                        formData.append(`added_questions[${qIndex}][image]`, question.image);
                    }
                    
                    question.answers.forEach((answer, aIndex) => {
                        formData.append(`added_questions[${qIndex}][answers][${aIndex}][text]`, answer.text);
                        formData.append(`added_questions[${qIndex}][answers][${aIndex}][true_status]`, answer.true_status ? '1' : '0');
                        
                        if (answer.image) {
                            formData.append(`added_questions[${qIndex}][answers][${aIndex}][image]`, answer.image);
                        }
                    });
                });
            }
            
            // Handle selected questions from bank
            if (testData.questions) {
                testData.questions.forEach((question, qIndex) => {
                    formData.append(`questions[${qIndex}][question_id]`, question.question_id);
                    formData.append(`questions[${qIndex}][question_degree]`, question.question_degree);
                });
            }
            
            const response = await axios.post(
                'https://newalemny.3almny.app/api/tests/add_new',
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    }
                }
            );
            
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'حدث خطأ في إنشاء الاختبار'
            );
        }
    }
);

const initialState = {
    tests: [],
    loading: false,
    error: null,
    pagination: {
        current_page: 1,
        total: 0,
        per_page: 12,
        pages_count: 0
    },
    currentClassId: null,
    currentPage: 1
};

const teacherTestsSlice = createSlice({
    name: 'teacherTests',
    initialState,
    reducers: {
        setCurrentClassId: (state, action) => {
            state.currentClassId = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        clearTests: (state) => {
            state.tests = [];
            state.error = null;
            state.pagination = {
                current_page: 1,
                total: 0,
                per_page: 12,
                pages_count: 0
            };
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch tests
            .addCase(fetchTeacherClassTests.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTeacherClassTests.fulfilled, (state, action) => {
                state.loading = false;
                state.tests = action.payload.result?.data || action.payload.data || [];
                state.pagination = action.payload.result?.pagination || action.payload.pagination || {
                    current_page: 1,
                    total: 0,
                    per_page: 12,
                    pages_count: 0
                };
                state.error = null;
            })
            .addCase(fetchTeacherClassTests.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Create test
            .addCase(createTest.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createTest.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                // Optionally add the new test to the list
                if (action.payload.result?.data) {
                    state.tests.unshift(action.payload.result.data);
                }
            })
            .addCase(createTest.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setCurrentClassId, setCurrentPage, clearTests } = teacherTestsSlice.actions;
export default teacherTestsSlice.reducer;
